import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-store';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuardService implements CanActivate {

  constructor(private ls: LocalStorageService,
    private authService: AuthService,
    private router: Router) { }

  canActivate(router: ActivatedRouteSnapshot): boolean {
    let expectedRole = '';
    const takeRole = router.data.expectedRole;
    const lsRole = this.ls.get('role');
    takeRole.forEach(element => {
      if (element == lsRole) {
        expectedRole = element;
      }
    });
    if (!this.authService.isAuthenticated() || lsRole !== expectedRole) {
      return false;
    }
    return true;
  }
}
